/* eslint-disable no-unused-vars */
import { Button, Grid, IconButton } from "@mui/material";
import { ThemeProvider } from "@mui/material/styles";

import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import AsyncSelect from "react-select/async";
import SearchIcon from "@mui/icons-material/Search";
import { SyncUtils } from "../../utils/SyncUtils";
import { createTheme } from "@mui/material/styles";

const theme = createTheme({
  overrides: {
    MuiIconButton: {
      root: {
        padding: 7,
      },
    },
  },
});

export default function SearchBar(props) {
  const { t } = useTranslation();
  const translate = t;
  const [prodLookupValue, setProdLookupValue] = useState();

  const getOptions = (inputValue, callback) => {
    getOptionsAsync(inputValue, callback);
  };

  async function getOptionsAsync(inputValue, callback) {
    let productTypes = null;
    let posFlag = null;
    if (props.context.appType === "M_POS") {
      productTypes = ["P"];
      posFlag = true;
    }
    if (props.context.appType === "R_POS") {
      productTypes = ["R"];
      posFlag = true;
    }
    let arr = await SyncUtils.searchInCache(
      props.productCache,
      inputValue,
      100,
      productTypes,
      posFlag
    );
    return callback(
      arr.map(function (option, index) {
        return {
          value: option,
          label: option,
        };
      })
    );

    //return callback([]);
  }

  const formatOptionLabel = (option, { context }) => {
    let strFactor = "";
    if (option?.value?.factor) {
      let factor = parseInt(option.value.factor);
      strFactor = "(" + factor + ")";
    }
    if (context === "menu") {
      return (
        <Grid container>
          <Grid item xs={3}>
            {option.value.unitType} {strFactor}
          </Grid>
          <Grid item xs={6}>
            {option.value.name}
          </Grid>
          <Grid item xs={3}>
            {option.value.price}
          </Grid>
        </Grid>
      );
    }
    if (!option.label) return "";
    return option.label.name;
  };

  const productLookupChanged = (newValue) => {
    prodSelected(newValue);
  };

  async function prodSelected(newValue) {
    let [prodBean, pricingBean] = await SyncUtils.getProductBean(
      newValue.value
    );
    if (prodBean == null || pricingBean == null) {
      alert("Product got Deleted or Modifed, please Reload the Window");
    } else {
      props.onAddProduct(prodBean, pricingBean);
    }
    setProdLookupValue({ label: null, value: null });
  }

  return (
    <ThemeProvider theme={theme}>
      <Grid container>
        <Grid item xs={props.isLookupEnabled ? 11 : 12}>
          <AsyncSelect
            formatOptionLabel={formatOptionLabel}
            components={{ formatOptionLabel }}
            menuPortalTarget={document.body}
            menuPosition={"fixed"}
            styles={{
              menuPortal: (base) => ({
                ...base,
                zIndex: 99999,
              }),
              marginRight: "10px",
            }}
            placeholder={translate(
              props.prompt ? props.prompt : "Search or Scan the product"
            )}
            loadOptions={getOptions}
            onChange={productLookupChanged}
            onKeyDown={(e) => {
              if (
                e.key == "F1" ||
                e.key == "F2" ||
                e.key == "F3" ||
                e.key == "F4" ||
                e.key == "F5" ||
                e.key == "F6" ||
                e.key == "F7" ||
                e.key == "F8" ||
                e.key == "F9" ||
                e.key == "F10" ||
                e.key == "F11" ||
                e.key == "F12"
              ) {
                e.preventDefault();
                props.handleKeyPress(e);
              }
              e.stopPropagation();
              e.nativeEvent.stopImmediatePropagation();
            }}
            value={prodLookupValue}
            //options={cities}
          />
        </Grid>
        {props.isLookupEnabled && (
          <Grid item xs={1}>
            <IconButton
              color="primary"
              aria-label="upload picture"
              component="span"
              style={{
                marginLeft: 20,
              }}
              fullWidth
              onClick={(e) => {}}
              onMouseDown={(e) => {
                props.setShowProductLookup(true);
              }}
              onFocus={(e) => {}}
              onKeyUp={(e) => {}}
            >
              <SearchIcon />
            </IconButton>
          </Grid>
        )}
      </Grid>
    </ThemeProvider>
  );
}
